import React from "react";
import Container from 'react-bootstrap/Container';

import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';


const InternshipAndStudentEmploymentOpportunities  = () =>{
  
  return (
    <div className="InternshipAndStudentEmploymentOpportunities">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/student-employment-opportunities.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                {/* <BreadcrumbItem active>About</BreadcrumbItem> */}
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Internship & student employment Opportunities </BreadcrumbItem>
            </Breadcrumb>
            <div className='information-content'>
              <h2>Internship & student employment Opportunities </h2>
              <p>For career and professional growth, the Library provides Internship opportunities to Library Science fresh graduates during the summer, and student employment opportunities for Habib University students during semester, summer and winter breaks. For more details, write to <a href="mailto:library@habib.edu.pk">library@habib.edu.pk</a></p>
            </div>
         </Container>
    </section>
   
  </div>
  );
}
export default InternshipAndStudentEmploymentOpportunities ;